export var MegaLoaderInstallEvent;
(function (MegaLoaderInstallEvent) {
    MegaLoaderInstallEvent["InstallProgress"] = "install-progress";
    MegaLoaderInstallEvent["InstallError"] = "install-error";
    MegaLoaderInstallEvent["Installed"] = "installed";
    MegaLoaderInstallEvent["Uninstalled"] = "uninstalled";
    MegaLoaderInstallEvent["UninstallError"] = "uninstall-error";
})(MegaLoaderInstallEvent || (MegaLoaderInstallEvent = {}));
export var MegaLoaderInstallStageType;
(function (MegaLoaderInstallStageType) {
    MegaLoaderInstallStageType["WillRetrieveManifest"] = "will-retrieve-manifest";
    MegaLoaderInstallStageType["WillDownload"] = "will-download";
    MegaLoaderInstallStageType["WillValidate"] = "will-validate";
    MegaLoaderInstallStageType["WillUnarchive"] = "will-unarchive";
    MegaLoaderInstallStageType["WillInstall"] = "will-install";
    MegaLoaderInstallStageType["DidInstall"] = "did-install";
})(MegaLoaderInstallStageType || (MegaLoaderInstallStageType = {}));
export var MegaResourceType;
(function (MegaResourceType) {
    MegaResourceType["DLL"] = "dll";
    MegaResourceType["Executable"] = "executable";
    MegaResourceType["Asset"] = "asset";
    MegaResourceType["Addon"] = "addon";
})(MegaResourceType || (MegaResourceType = {}));
//# sourceMappingURL=mega-loader-service.protocol.js.map